import { render, staticRenderFns } from "./ProcedureCreate.vue?vue&type=template&id=8ab9d9c0&scoped=true&"
import script from "./ProcedureCreate.vue?vue&type=script&lang=js&"
export * from "./ProcedureCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureCreate.vue?vue&type=style&index=0&id=8ab9d9c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab9d9c0",
  null
  
)

export default component.exports